// liability Saga
import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  GET_LIABILITY_LIST,
  GET_LIABILITY_DETAIL,
  CREATE_LIABILITY,
  UPDATE_LIABILITY,
  DELETE_LIABILITY,
  GET_LIABILITY_PROVIDER_LIST,
  GET_LIABILITY_PROVIDER_DETAIL,
  CREATE_LIABILITY_PROVIDER,
  UPDATE_LIABILITY_PROVIDER,
  DELETE_LIABILITY_PROVIDER,
  GET_LIABILITY_STATUS_LIST,
  GET_LIABILITY_STATUS_DETAIL,
  CREATE_LIABILITY_STATUS,
  UPDATE_LIABILITY_STATUS,
  DELETE_LIABILITY_STATUS,
  GET_LIABILITY_ITEM_CATEGORY_LIST,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL,
  CREATE_LIABILITY_ITEM_CATEGORY,
  UPDATE_LIABILITY_ITEM_CATEGORY,
  DELETE_LIABILITY_ITEM_CATEGORY,
} from "./actionType";

import {
  getLiabilityListSuccess,
  getLiabilityListFailure,
  getLiabilityDetailSuccess,
  getLiabilityDetailFailure,
  createLiabilitySuccess,
  createLiabilityFailure,
  updateLiabilitySuccess,
  updateLiabilityFailure,
  deleteLiabilitySuccess,
  deleteLiabilityFailure,
  getLiabilityProviderListSuccess,
  getLiabilityProviderListFailure,
  getLiabilityProviderDetailSuccess,
  getLiabilityProviderDetailFailure,
  createLiabilityProviderSuccess,
  createLiabilityProviderFailure,
  updateLiabilityProviderSuccess,
  updateLiabilityProviderFailure,
  deleteLiabilityProviderSuccess,
  deleteLiabilityProviderFailure,
  getLiabilityStatusListSuccess,
  getLiabilityStatusListFailure,
  getLiabilityStatusDetailSuccess,
  getLiabilityStatusDetailFailure,
  createLiabilityStatusSuccess,
  createLiabilityStatusFailure,
  updateLiabilityStatusSuccess,
  updateLiabilityStatusFailure,
  deleteLiabilityStatusSuccess,
  deleteLiabilityStatusFailure,
  getLiabilityItemCategoryListSuccess,
  getLiabilityItemCategoryListFailure,
  getLiabilityItemCategoryDetailSuccess,
  getLiabilityItemCategoryDetailFailure,
  createLiabilityItemCategorySuccess,
  createLiabilityItemCategoryFailure,
  updateLiabilityItemCategorySuccess,
  updateLiabilityItemCategoryFailure,
  deleteLiabilityItemCategorySuccess,
  deleteLiabilityItemCategoryFailure,
} from "./action";

import {
  getLiabilityListApi,
  getLiabilityDetailApi,
  createLiabilityApi,
  updateLiabilityApi,
  deleteLiabilityApi,
  getLiabilityProviderListApi,
  getLiabilityProviderDetailApi,
  createLiabilityProviderApi,
  updateLiabilityProviderApi,
  deleteLiabilityProviderApi,
  getLiabilityStatusListApi,
  getLiabilityStatusDetailApi,
  createLiabilityStatusApi,
  updateLiabilityStatusApi,
  deleteLiabilityStatusApi,
  getLiabilityItemCategoryListApi,
  getLiabilityItemCategoryDetailApi,
  createLiabilityItemCategoryApi,
  updateLiabilityItemCategoryApi,
  deleteLiabilityItemCategoryApi,
} from "../../helpers/fakebackend_helper";

// Get liability List
function* getLiabilityListSaga() {
  try {
    const response = yield call(getLiabilityListApi);
    yield put(getLiabilityListSuccess(response));
  } catch (error) {
    yield put(getLiabilityListFailure(error));
  }
}

function* watchLiabilityList() {
  yield takeLatest(GET_LIABILITY_LIST, getLiabilityListSaga);
}

// Get liability Detail
function* getLiabilityDetailSaga(action) {
  try {
    const response = yield call(getLiabilityDetailApi, action.payload);
    yield put(getLiabilityDetailSuccess(response));
  } catch (error) {
    yield put(getLiabilityDetailFailure(error));
  }
}

function* watchGetLiabilityDetailSaga() {
  yield takeLatest(GET_LIABILITY_DETAIL, getLiabilityDetailSaga);
}
// Create liability
function* createLiabilitySaga(action) {
  try {
    const response = yield call(createLiabilityApi, action.payload);
    yield put(createLiabilitySuccess(response));
  } catch (error) {
    yield put(createLiabilityFailure(error));
  }
}

function* watchCreateLiabilitySaga() {
  yield takeLatest(CREATE_LIABILITY, createLiabilitySaga);
}

// Update liability
function* updateLiabilitySaga(action) {
  try {
    const response = yield call(updateLiabilityApi, action.payload);
    yield put(updateLiabilitySuccess(response));
  } catch (error) {
    yield put(updateLiabilityFailure(error));
  }
}

function* watchUpdateLiabilitySaga() {
  yield takeLatest(UPDATE_LIABILITY, updateLiabilitySaga);
}

// Delete liability
function* deleteLiabilitySaga(action) {
  try {
    const response = yield call(deleteLiabilityApi, action.payload);
    yield put(deleteLiabilitySuccess(response));
  } catch (error) {
    yield put(deleteLiabilityFailure(error));
  }
}

function* watchDeleteLiabilitySaga() {
  yield takeLatest(DELETE_LIABILITY, deleteLiabilitySaga);
}

// Get Liability Provider List
function* getLiabilityProviderListSaga() {
  try {
    const response = yield call(getLiabilityProviderListApi);
    yield put(getLiabilityProviderListSuccess(response));
  } catch (error) {
    yield put(getLiabilityProviderListFailure(error));
  }
}

function* watchLiabilityProviderList() {
  yield takeLatest(GET_LIABILITY_PROVIDER_LIST, getLiabilityProviderListSaga);
}

// Get Liability Provider Detail
function* getLiabilityProviderDetailSaga(action) {
  try {
    const response = yield call(getLiabilityProviderDetailApi, action.payload);
    yield put(getLiabilityProviderDetailSuccess(response));
  } catch (error) {
    yield put(getLiabilityProviderDetailFailure(error));
  }
}

function* watchGetLiabilityProviderDetailSaga() {
  yield takeLatest(
    GET_LIABILITY_PROVIDER_DETAIL,
    getLiabilityProviderDetailSaga
  );
}

// Create Liability Provider
function* createLiabilityProviderSaga(action) {
  try {
    const response = yield call(createLiabilityProviderApi, action.payload);
    yield put(createLiabilityProviderSuccess(response));
  } catch (error) {
    yield put(createLiabilityProviderFailure(error));
  }
}

function* watchCreateLiabilityProviderSaga() {
  yield takeLatest(CREATE_LIABILITY_PROVIDER, createLiabilityProviderSaga);
}

// Update Liability Provider
function* updateLiabilityProviderSaga(action) {
  try {
    const response = yield call(updateLiabilityProviderApi, action.payload);
    yield put(updateLiabilityProviderSuccess(response));
  } catch (error) {
    yield put(updateLiabilityProviderFailure(error));
  }
}

function* watchUpdateLiabilityProviderSaga() {
  yield takeLatest(UPDATE_LIABILITY_PROVIDER, updateLiabilityProviderSaga);
}

// Delete Liability Provider
function* deleteLiabilityProviderSaga(action) {
  try {
    const response = yield call(deleteLiabilityProviderApi, action.payload);
    yield put(deleteLiabilityProviderSuccess(response));
  } catch (error) {
    yield put(deleteLiabilityProviderFailure(error));
  }
}

function* watchDeleteLiabilityProviderSaga() {
  yield takeLatest(DELETE_LIABILITY_PROVIDER, deleteLiabilityProviderSaga);
}
// Get Liability Status List
function* getLiabilityStatusListSaga() {
  try {
    const response = yield call(getLiabilityStatusListApi);
    yield put(getLiabilityStatusListSuccess(response));
  } catch (error) {
    yield put(getLiabilityStatusListFailure(error));
  }
}

function* watchLiabilityStatusList() {
  yield takeLatest(GET_LIABILITY_STATUS_LIST, getLiabilityStatusListSaga);
}

// Get Liability Status Detail
function* getLiabilityStatusDetailSaga(action) {
  try {
    const response = yield call(getLiabilityStatusDetailApi, action.payload);
    yield put(getLiabilityStatusDetailSuccess(response));
  } catch (error) {
    yield put(getLiabilityStatusDetailFailure(error));
  }
}

function* watchGetLiabilityStatusDetailSaga() {
  yield takeLatest(GET_LIABILITY_STATUS_DETAIL, getLiabilityStatusDetailSaga);
}

// Create Liability Status
function* createLiabilityStatusSaga(action) {
  try {
    const response = yield call(createLiabilityStatusApi, action.payload);
    yield put(createLiabilityStatusSuccess(response));
  } catch (error) {
    yield put(createLiabilityStatusFailure(error));
  }
}

function* watchCreateLiabilityStatusSaga() {
  yield takeLatest(CREATE_LIABILITY_STATUS, createLiabilityStatusSaga);
}

// Update Liability Status
function* updateLiabilityStatusSaga(action) {
  try {
    const response = yield call(updateLiabilityStatusApi, action.payload);
    yield put(updateLiabilityStatusSuccess(response));
  } catch (error) {
    yield put(updateLiabilityStatusFailure(error));
  }
}

function* watchUpdateLiabilityStatusSaga() {
  yield takeLatest(UPDATE_LIABILITY_STATUS, updateLiabilityStatusSaga);
}

// Delete Liability Status
function* deleteLiabilityStatusSaga(action) {
  try {
    const response = yield call(deleteLiabilityStatusApi, action.payload);
    yield put(deleteLiabilityStatusSuccess(response));
  } catch (error) {
    yield put(deleteLiabilityStatusFailure(error));
  }
}

function* watchDeleteLiabilityStatusSaga() {
  yield takeLatest(DELETE_LIABILITY_STATUS, deleteLiabilityStatusSaga);
}

// Get Liability Item Category List
function* getLiabilityItemCategoryListSaga() {
  try {
    const response = yield call(getLiabilityItemCategoryListApi);
    yield put(getLiabilityItemCategoryListSuccess(response));
  } catch (error) {
    yield put(getLiabilityItemCategoryListFailure(error));
  }
}

function* watchLiabilityItemCategoryList() {
  yield takeLatest(
    GET_LIABILITY_ITEM_CATEGORY_LIST,
    getLiabilityItemCategoryListSaga
  );
}

// Get Liability Item Category Detail
function* getLiabilityItemCategoryDetailSaga(action) {
  try {
    const response = yield call(
      getLiabilityItemCategoryDetailApi,
      action.payload
    );
    yield put(getLiabilityItemCategoryDetailSuccess(response));
  } catch (error) {
    yield put(getLiabilityItemCategoryDetailFailure(error));
  }
}

function* watchGetLiabilityItemCategoryDetailSaga() {
  yield takeLatest(
    GET_LIABILITY_ITEM_CATEGORY_DETAIL,
    getLiabilityItemCategoryDetailSaga
  );
}

// Create Liability Item Category
function* createLiabilityItemCategorySaga(action) {
  try {
    const response = yield call(createLiabilityItemCategoryApi, action.payload);
    yield put(createLiabilityItemCategorySuccess(response));
  } catch (error) {
    yield put(createLiabilityItemCategoryFailure(error));
  }
}

function* watchCreateLiabilityItemCategorySaga() {
  yield takeLatest(
    CREATE_LIABILITY_ITEM_CATEGORY,
    createLiabilityItemCategorySaga
  );
}

// Update Liability Item Category
function* updateLiabilityItemCategorySaga(action) {
  try {
    const response = yield call(updateLiabilityItemCategoryApi, action.payload);
    yield put(updateLiabilityItemCategorySuccess(response));
  } catch (error) {
    yield put(updateLiabilityItemCategoryFailure(error));
  }
}

function* watchUpdateLiabilityItemCategorySaga() {
  yield takeLatest(
    UPDATE_LIABILITY_ITEM_CATEGORY,
    updateLiabilityItemCategorySaga
  );
}

// Delete Liability Item Category
function* deleteLiabilityItemCategorySaga(action) {
  try {
    const response = yield call(deleteLiabilityItemCategoryApi, action.payload);
    yield put(deleteLiabilityItemCategorySuccess(response));
  } catch (error) {
    yield put(deleteLiabilityItemCategoryFailure(error));
  }
}

function* watchDeleteLiabilityItemCategorySaga() {
  yield takeLatest(
    DELETE_LIABILITY_ITEM_CATEGORY,
    deleteLiabilityItemCategorySaga
  );
}

export default function* Liability() {
  yield all([
    watchLiabilityList(),
    watchGetLiabilityDetailSaga(),
    watchCreateLiabilitySaga(),
    watchUpdateLiabilitySaga(),
    watchDeleteLiabilitySaga(),
    watchLiabilityProviderList(),
    watchGetLiabilityProviderDetailSaga(),
    watchCreateLiabilityProviderSaga(),
    watchUpdateLiabilityProviderSaga(),
    watchDeleteLiabilityProviderSaga(),
    watchLiabilityStatusList(),
    watchGetLiabilityStatusDetailSaga(),
    watchCreateLiabilityStatusSaga(),
    watchUpdateLiabilityStatusSaga(),
    watchDeleteLiabilityStatusSaga(),
    watchLiabilityItemCategoryList(),
    watchGetLiabilityItemCategoryDetailSaga(),
    watchCreateLiabilityItemCategorySaga(),
    watchUpdateLiabilityItemCategorySaga(),
    watchDeleteLiabilityItemCategorySaga(),
  ]);
}
